import React from 'react'
import { useGetScheduleLabel } from 'lib/family-cup-utils/event-dates'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  schedule: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      marginBottom: theme.spacing(1),
    },
  },
}))

export default function Schedule({ hit }) {
  const classes = useStyles()
  const scheduleLabel = useGetScheduleLabel(hit)
  return (
    <Typography variant="h5" className={classes.schedule}>
      {scheduleLabel}
    </Typography>
  )
}
